'use client';

import { type ReactNode, createContext, useContext, useState } from 'react';

import { SurveyOverlay } from '@/features/home/porsline/SurveyOverlay';

import { SurveyConfig } from '@/common/constants/porsline';

type SurveyContextType = {
  openSurvey: (survey: SurveyConfig) => void;
  closeSurvey: () => void;
};

const SurveyContext = createContext<SurveyContextType | null>(null);

export function SurveyProvider({ children }: { children: ReactNode }) {
  const [survey, setSurvey] = useState<SurveyConfig | null>(null);

  return (
    <SurveyContext.Provider
      value={{
        openSurvey: setSurvey,
        closeSurvey: () => setSurvey(null),
      }}
    >
      {children}

      <SurveyOverlay survey={survey} onClose={() => setSurvey(null)} />
    </SurveyContext.Provider>
  );
}

export function useSurvey() {
  const context = useContext(SurveyContext);

  if (!context) {
    throw new Error('useSurvey must be used inside SurveyProvider');
  }

  return context;
}
